import { QuoteToolEnvironment } from '@lx/quote-tool/lite/shared/types';

/**
 * Online Quote Tool specific environment type.
 * Extends QuoteToolEnvironment to support return URL functionality and company configuration.
 */
export type OnlineQuoteToolEnvironment = QuoteToolEnvironment;
